import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA8tN3s4o4mGH74Gjy_qh9Y17-pST_HH08",
  authDomain: "goldbilisim-serdar.firebaseapp.com",
  projectId: "goldbilisim-serdar",
  storageBucket: "goldbilisim-serdar.firebasestorage.app",
  messagingSenderId: "449008231837",
  appId: "1:449008231837:web:b4a5ea58a88a7882b3fb74",
  measurementId: "G-7DEB7KZP0L"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
